export default __webpack_public_path__ + "static/media/cleaning.af315988.png";